module.exports = __webpack_public_path__ + "img/3.69c8ae93.svg";